export default __webpack_public_path__ + "media/blog-abst.0c345244.svg";